import { NOTIFICATION_DELAY_MS } from 'src/constants';

export const createRoleUpdateTimeKey = (uid: string, bpid: string): string => {
  return `${uid} ${bpid}`;
};

export const notificationWithTimeoutHandler = (
  uid: string,
  orgId: string
): {
  saveTimestamp: () => void;
  removeTimestamp: () => void;
  getTimestamp: () => string | null;
  hasTimePassed: () => boolean;
  startTimeout: (callback: (state: boolean) => void) => void;
} => {
  const key = createRoleUpdateTimeKey(uid, orgId);
  const ms = NOTIFICATION_DELAY_MS;

  const saveTimestamp = () => {
    const timestamp = new Date().toISOString();
    localStorage.setItem(key, timestamp);
  };

  const removeTimestamp = () => {
    localStorage.removeItem(key);
  };

  const getTimestamp = () => {
    return localStorage.getItem(key);
  };

  const hasTimePassed = () => {
    const notificationCreatedAt = getTimestamp();
    const currentTime = new Date().toISOString();
    if (notificationCreatedAt) {
      const differenceInMs = Math.abs(
        Date.parse(currentTime) - Date.parse(notificationCreatedAt)
      );
      return ms - differenceInMs < 0;
    }
    return true;
  };

  const startTimeout = (callback: (state: boolean) => void) => {
    callback(!hasTimePassed());
    setTimeout(() => {
      if (hasTimePassed()) {
        removeTimestamp();
        callback(false);
      } else {
        callback(true);
      }
    }, ms);
  };

  return {
    saveTimestamp,
    removeTimestamp,
    getTimestamp,
    hasTimePassed,
    startTimeout,
  };
};
